import styled from 'styled-components';

const StyledBidEntry = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  min-height: max-content;
`;

StyledBidEntry.Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  line-height: 30px;
  min-height: max-content;
`;

StyledBidEntry.Amount = styled.div`
  width: auto;
  margin-right: 12px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE_SIZE};
  min-height: max-content;
  white-space: nowrap;
`;

StyledBidEntry.Time = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};

  b {
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    font-weight: unset;
  }
`;

export { StyledBidEntry };

const StyledBidUser = {};

StyledBidUser.Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  line-height: 16px;
  margin: -5px 0 15px 0;
`;

StyledBidUser.Name = styled.div`
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  margin-right: 12px;

  a,
  a:visited {
    text-decoration: none;
    color: ${({ theme }) => theme.COLORS.TERTIARY};
  }

  a:hover {
    text-decoration: underline;
  }
`;

StyledBidUser.CompanyName = styled.div`
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;

export { StyledBidUser };

const StyledAuctionStateUpdate = styled.div`
  margin-bottom: 12px;
`;

StyledAuctionStateUpdate.State = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  margin-bottom: 10px;
`;

StyledAuctionStateUpdate.Time = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;

export { StyledAuctionStateUpdate };
